export { default, type ITextProps } from './Text';
